module.exports = __webpack_public_path__ + "static/us-pikes-peak.127b5415.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/images/us-pikes-peak.jpg
// module id = 635
// module chunks = 35783957827783